import { Box, Typography } from "@mui/material";
import { getAggregatorColor } from "@src/pages/Analytics/components/AggregatorSelect";
import React, { FC } from "react";
import {
  LineChart,
  CartesianGrid,
  XAxis,
  YAxis,
  Tooltip,
  Line,
  ResponsiveContainer,
} from "recharts";
import { Graph } from "../domain/model/GraphConfig";

interface AnalyticsLinearGraphProps {
  selectedAggregators: string[];
  toolTipTitle: string;
  data: Graph[];
}

export const AnalyticsLinearGraph: FC<AnalyticsLinearGraphProps> = (props) => {
  const { selectedAggregators, data } = props;

  return (
    <>
      {data.length > 0 && (
        <Box width={"100%"} height={"500px"} marginTop={"60px"}>
          <ResponsiveContainer width="100%" height="100%">
            <LineChart data={data} width={500} height={300}>
              <YAxis
                width={
                  Math.max(
                    data[data.length - 1].glovo,
                    data[data.length - 1].wolt,
                    data[data.length - 1].yandex
                  )
                    .toString()
                    .split("").length * 15
                }
              />
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="name" />
              <Tooltip
                content={({ active, payload, label }) => {
                  if (active && payload && payload.length) {
                    const date = data.filter((g) => g.name === label)[0].date;
                    return (
                      <Box
                        bgcolor={"white"}
                        sx={{
                          boxShadow: 2,
                          padding: "15px",
                          borderRadius: "5px",
                        }}
                      >
                        <Typography
                          fontSize={"14px"}
                          color={"#BEBEBE"}
                        >{`${date}`}</Typography>
                        <Typography fontSize={"14px"}>
                          {props.toolTipTitle}:
                        </Typography>
                        {payload.map((p, index) => {
                          return (
                            <Box
                              display={"flex"}
                              flexDirection={"row"}
                              key={index}
                              alignItems={"center"}
                            >
                              <Box
                                bgcolor={p.color}
                                borderRadius={"300px"}
                                width={"16px"}
                                height={"16px"}
                                marginRight={"10px"}
                              />
                              <Typography fontSize={"14px"}>
                                {p.name} {p.value}
                              </Typography>
                            </Box>
                          );
                        })}
                      </Box>
                    );
                  }

                  return null;
                }}
              />
              {selectedAggregators.includes("wolt") && (
                <Line
                  type="monotone"
                  dataKey="wolt"
                  stroke={getAggregatorColor("wolt")}
                />
              )}
              {selectedAggregators.includes("yandex") && (
                <Line
                  type="monotone"
                  dataKey="yandex"
                  stroke={getAggregatorColor("yandex")}
                />
              )}
              {selectedAggregators.includes("glovo") && (
                <Line
                  type="monotone"
                  dataKey="glovo"
                  stroke={getAggregatorColor("glovo")}
                />
              )}
              {selectedAggregators.includes("all") && (
                <Line
                  type="monotone"
                  dataKey="all"
                  stroke={getAggregatorColor("all")}
                />
              )}
            </LineChart>
          </ResponsiveContainer>
        </Box>
      )}
    </>
  );
};